<template>
  <div>
    <Head title="Create Mail Template" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/mail/templates">Mail Templates</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Edit Mail PDF</li>
      </ol>
    </nav>
    <h1>Edit Mail Template</h1>

    <div class="content-box">
      <form @submit.prevent="update">
        <MailTemplateForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Template</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import MailTemplateForm from './components/MailTemplateForm'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    MailTemplateForm,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    mailtemplates: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.mailtemplates.name,
        code: this.mailtemplates.code,
        group: this.mailtemplates.group,
        html_template: this.mailtemplates.html_template
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/settings/mail/templates/${this.mailtemplates.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this mail template?')) {
        this.$inertia.delete(`/settings/mail/templates/${this.mailtemplates.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this mail template?')) {
        this.$inertia.put(`/settings/mail/templates/${this.mailtemplates.id}/restore`)
      }
    },
  },
}
</script>
